import { exists } from '@/api'

export interface BatchForcedReturnCondition {
  lendDateFrom: string
  lendDateTo: string
  dueDateFrom: string
  dueDateTo: string
  branchCode: string
  branchType: string
  isChangeUserStatus: boolean
  isUpdate: boolean
  collectionStatus: string
  isRemove: boolean
  removeReason: string
}

export function BatchForcedReturnConditionFromJSON(
  json: any
): BatchForcedReturnCondition {
  const _json = JSON.parse(json)

  return {
    lendDateFrom: exists(_json, 'lend_date_from') ? _json.lend_date_from : '',
    lendDateTo: exists(_json, 'lend_date_to') ? _json.lend_date_to : '',
    dueDateFrom: exists(_json, 'due_date_from') ? _json.due_date_from : '',
    dueDateTo: exists(_json, 'due_date_to') ? _json.due_date_to : '',
    branchCode: exists(_json, 'branch_code') ? _json.branch_code : '',
    branchType: exists(_json, 'branch_type') ? _json.branch_type : '1',
    isChangeUserStatus: exists(_json, 'is_change_user_status')
      ? _json.is_change_user_status
      : false,
    isUpdate: exists(_json, 'is_update') ? _json.is_update : false,
    collectionStatus: exists(_json, 'collection_status')
      ? _json.collection_status
      : '1',
    isRemove: exists(_json, 'is_remove') ? _json.is_remove : false,
    removeReason: exists(_json, 'remove_reason') ? _json.remove_reason : ''
  }
}
